module.exports = __webpack_public_path__ + "img/google-play-store-btn-EN.b6b1384e.svg";